import axios from 'axios'

export const state = {
    items: {
        title: null,
        description: null,
        handle: null,
        products: [],
        meta: {
            current_page: 1,
            pages: 1,
            total: 0,
        },
    },
}

export const mutations = {
    SET_DATA(state, data) {
        state.items = data
    },
}

export const actions = {
    async FETCH({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios
                .get('/collections/safety-data-sheets?view=json')
                .then((response) => {
                    const data = JSON.parse(JSON.stringify(response.data))
                    commit('SET_DATA', data)
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
        })
    },
}
